import { logFeature } from '@office-start/telemetry-service';
export function logFirstRunNavigation(_a) {
    // TODO: implement latency
    // const currentSlideInteractionTime = Math.ceil(
    //     Performance.now() - slideStartTime,
    // ).toString();
    var action = _a.action, currentSlideIndex = _a.currentSlideIndex, totalSlideLength = _a.totalSlideLength, version = _a.version, 
    // slideStartTime,
    firstRunType = _a.firstRunType;
    var params = {
        Action: action,
        FirstRunCurrentSlideIndex: currentSlideIndex,
        FirstRunTotalSlideLength: totalSlideLength,
        FirstRunVersion: version,
        FirstRunType: firstRunType,
        // Latency: currentSlideInteractionTime,
    };
    if (action === 'secondRunComplete') {
        logFeature({
            featureName: "FirstRun" /* KnownFeatureNames.FirstRun */,
            eventName: 'Second_Run_Navigation',
            params: params,
            area: 'SecondRun',
        });
    }
    else {
        logFeature({
            featureName: "FirstRun" /* KnownFeatureNames.FirstRun */,
            eventName: 'First_Run_Navigation',
            params: params,
            area: 'FirstRun',
        });
    }
}
//# sourceMappingURL=logFirstRunNavigation.js.map